/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getStats } = actions;

export default () => {
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const { isLogin } = authReducer;
  return useEffect(() => {
    if (isLogin) {
      dispatch(getStats());
    }
  }, [authReducer.isLogin]);
};
